if (!customElements.get('banzoo-bundle-offer')) {
  customElements.define(
    'banzoo-bundle-offer',
    class BanzooBundleOffer extends HTMLElement {
      connectedCallback() {
        this.products = this.querySelector(
          '.banzoo-bundle__products'
        );

        this.message = this.querySelector(
          '.banzoo-bundle__message'
        );

        this.dropdown = this.querySelector(
          '.banzoo-bundle__custom-dropdown'
        );

        this.dropdownToggle = this.querySelector(
          '.banzoo-bundle__dropdown-toggle'
        );

        this.dropdownMenu = this.querySelector(
          '.banzoo-bundle__dropdown-menu'
        );

        this.dropdownOptions = Array.from(
          this.querySelectorAll(
            '.banzoo-bundle__dropdown-option'
          )
        );

        this.variantInput = this.querySelector(
          '.banzoo-bundle__variant-input'
        );

        this.discountCodeInput = this.querySelector(
          '.banzoo-bundle__discount-code-input'
        );

        this.selectedImage = this.querySelector(
          '.banzoo-bundle__selected-image'
        );

        this.selectedTitle = this.querySelector(
          '.banzoo-bundle__selected-title'
        );

        this.selectedVariant = this.querySelector(
          '.banzoo-bundle__selected-variant'
        );

        this.regularPrice = this.querySelector(
          '.banzoo-bundle__regular-price'
        );

        this.discountPrice = this.querySelector(
          '.banzoo-bundle__discount-price'
        );

        this.saving = this.querySelector(
          '.banzoo-bundle__saving'
        );

        this.productForm = document.querySelector(
          `#product-form-${this.dataset.sectionId}`
        );

        this.productFormContainer =
          this.productForm?.closest('product-form') ||
          this.productForm;

        this.dealCard = this.querySelector(
          '.banzoo-bundle__deal-card'
        );

        this.singleChoice = this.querySelector(
          '.banzoo-bundle__choice--single'
        );

        this.submitButton = this.productForm?.querySelector(
          '[type="submit"]'
        );

        this.submitButtonText = this.submitButton?.querySelector(
          'span'
        );

        this.submitButton?.classList.add(
          'banzoo-bundle__submit'
        );

        this.choices = this.querySelectorAll(
          'input[type="radio"][value="single"], input[type="radio"][value="bundle"]'
        );

        this.choices.forEach((choice) => {
          choice.addEventListener('change', () => {
            this.updateChoice();
          });
        });

        this.dropdownToggle?.addEventListener(
          'click',
          () => {
            this.toggleDropdown();
          }
        );

        this.dropdownToggle?.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key === 'ArrowDown' ||
              event.key === 'ArrowUp'
            ) {
              event.preventDefault();
              this.openDropdown();

              const selectedOption =
                this.dropdownOptions.find(
                  (option) =>
                    option.getAttribute(
                      'aria-selected'
                    ) === 'true'
                ) || this.dropdownOptions[0];

              selectedOption?.focus();
            }
          }
        );

        this.dropdownOptions.forEach((option) => {
          option.addEventListener('click', () => {
            this.selectOption(option);
          });

          option.addEventListener(
            'keydown',
            (event) => {
              this.handleOptionKeydown(
                event,
                option
              );
            }
          );
        });

        this.documentClickHandler =
          this.handleDocumentClick.bind(this);

        document.addEventListener(
          'click',
          this.documentClickHandler
        );

        this.updateChoice();

        const firstSelectedOption =
          this.dropdownOptions.find(
            (option) =>
              option.getAttribute(
                'aria-selected'
              ) === 'true'
          ) || this.dropdownOptions[0];

        if (firstSelectedOption) {
          this.selectOption(
            firstSelectedOption,
            false
          );
        }

        if (this.productForm) {
          this.submitHandler =
            this.onSubmit.bind(this);

          this.productForm.addEventListener(
            'submit',
            this.submitHandler,
            true
          );
        }
      }

      disconnectedCallback() {
        document.removeEventListener(
          'click',
          this.documentClickHandler
        );

        if (
          this.productForm &&
          this.submitHandler
        ) {
          this.productForm.removeEventListener(
            'submit',
            this.submitHandler,
            true
          );
        }
      }

      updateChoice() {
        const bundleSelected =
          this.querySelector(
            'input[value="bundle"]:checked'
          );

        if (this.products) {
          this.products.hidden =
            !bundleSelected;
        }

        this.classList.toggle(
          'is-selected',
          Boolean(bundleSelected)
        );

        this.updateSubmitButton(
          Boolean(bundleSelected)
        );

        this.updateSubmitPlacement(
          Boolean(bundleSelected)
        );

        if (!bundleSelected) {
          this.closeDropdown();
        }

        this.showMessage();
      }

      updateSubmitButton(bundleSelected) {
        if (
          !this.submitButton ||
          !this.submitButtonText ||
          this.submitButton.disabled
        ) {
          return;
        }

        const singleButtonLabel =
          this.dataset.singleButtonLabel ||
          'Voeg product toe';

        this.submitButtonText.textContent =
          bundleSelected
            ? 'Voeg bundel toe'
            : singleButtonLabel;

        this.submitButton.classList.toggle(
          'is-bundle',
          bundleSelected
        );
      }

      updateSubmitPlacement(bundleSelected) {
        if (!this.productFormContainer) return;

        if (bundleSelected && this.dealCard) {
          this.dealCard.appendChild(
            this.productFormContainer
          );
        } else if (this.singleChoice) {
          this.singleChoice.insertAdjacentElement(
            'afterend',
            this.productFormContainer
          );
        }
      }

      toggleDropdown() {
        const isOpen =
          this.dropdownToggle?.getAttribute(
            'aria-expanded'
          ) === 'true';

        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      openDropdown() {
        if (
          !this.dropdownToggle ||
          !this.dropdownMenu
        ) {
          return;
        }

        this.dropdownToggle.setAttribute(
          'aria-expanded',
          'true'
        );

        this.dropdownMenu.hidden = false;
        this.dropdown?.classList.add('is-open');
      }

      closeDropdown() {
        if (
          !this.dropdownToggle ||
          !this.dropdownMenu
        ) {
          return;
        }

        this.dropdownToggle.setAttribute(
          'aria-expanded',
          'false'
        );

        this.dropdownMenu.hidden = true;
        this.dropdown?.classList.remove(
          'is-open'
        );
      }

      handleDocumentClick(event) {
        if (
          this.dropdown &&
          !this.dropdown.contains(event.target)
        ) {
          this.closeDropdown();
        }
      }

      handleOptionKeydown(event, option) {
        const currentIndex =
          this.dropdownOptions.indexOf(option);

        if (event.key === 'ArrowDown') {
          event.preventDefault();

          const nextOption =
            this.dropdownOptions[
              (currentIndex + 1) %
                this.dropdownOptions.length
            ];

          nextOption?.focus();
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();

          const previousOption =
            this.dropdownOptions[
              (
                currentIndex -
                1 +
                this.dropdownOptions.length
              ) %
                this.dropdownOptions.length
            ];

          previousOption?.focus();
        }

        if (event.key === 'Home') {
          event.preventDefault();
          this.dropdownOptions[0]?.focus();
        }

        if (event.key === 'End') {
          event.preventDefault();

          this.dropdownOptions[
            this.dropdownOptions.length - 1
          ]?.focus();
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeDropdown();
          this.dropdownToggle?.focus();
        }

        if (
          event.key === 'Enter' ||
          event.key === ' '
        ) {
          event.preventDefault();
          this.selectOption(option);
          this.dropdownToggle?.focus();
        }
      }

      selectOption(
        option,
        closeAfterSelection = true
      ) {
        if (!option || option.disabled) return;

        this.dropdownOptions.forEach(
          (dropdownOption) => {
            dropdownOption.setAttribute(
              'aria-selected',
              dropdownOption === option
                ? 'true'
                : 'false'
            );
          }
        );

        const variantId =
          option.dataset.variantId || '';

        const productTitle =
          option.dataset.productTitle || '';

        const variantTitle =
          option.dataset.variantTitle || '';

        const imageUrl =
          option.dataset.imageUrl || '';

        const regularPrice =
          option.dataset.regularPrice || '';

        const bundlePrice =
          option.dataset.bundlePrice || '';

        const saving =
          option.dataset.saving || '';

        const discountCode =
          option.dataset.discountCode || '';

        if (this.variantInput) {
          this.variantInput.value = variantId;
        }

        if (this.discountCodeInput) {
          this.discountCodeInput.value =
            discountCode;
        }

        if (this.selectedTitle) {
          this.selectedTitle.textContent =
            productTitle;
        }

        if (this.selectedVariant) {
          const hasVariant =
            variantTitle &&
            variantTitle !== 'Default Title';

          this.selectedVariant.textContent =
            hasVariant ? variantTitle : '';

          this.selectedVariant.hidden =
            !hasVariant;
        }

        if (this.selectedImage) {
          if (imageUrl) {
            this.selectedImage.src = imageUrl;
            this.selectedImage.alt =
              productTitle;
            this.selectedImage.hidden = false;
          } else {
            this.selectedImage.hidden = true;
          }
        }

        if (this.regularPrice) {
          this.regularPrice.textContent =
            regularPrice;
        }

        if (this.discountPrice) {
          this.discountPrice.textContent =
            bundlePrice;
        }

        if (this.saving) {
          this.saving.textContent =
            `Je bespaart ${saving}`;
        }

        if (closeAfterSelection) {
          this.closeDropdown();
        }
      }

      async fetchCurrentCart() {
        const shopRoot =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          `${shopRoot}cart.js`,
          {
            headers: {
              Accept: 'application/json',
              'X-Requested-With':
                'XMLHttpRequest',
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            'De actuele voorraad kon niet worden gecontroleerd. Probeer het opnieuw.'
          );
        }

        return response.json();
      }

      getCartVariantQuantity(cart, variantId) {
        return (cart?.items || []).reduce(
          (quantity, item) =>
            Number(item.id) === Number(variantId)
              ? quantity +
                Number(item.quantity || 0)
              : quantity,
          0
        );
      }

      hasEnoughInventory(
        option,
        cart,
        requestedQuantity = 1
      ) {
        if (
          !option ||
          option.dataset.inventoryTracked !== 'true'
        ) {
          return true;
        }

        const inventoryQuantity = Number(
          option.dataset.inventoryQuantity
        );

        const cartQuantity =
          this.getCartVariantQuantity(
            cart,
            option.dataset.variantId
          );

        return (
          cartQuantity + requestedQuantity <=
          inventoryQuantity
        );
      }

      disableUnavailableOption(option) {
        if (!option) return;

        option.disabled = true;
        option.hidden = true;
        option.setAttribute(
          'aria-disabled',
          'true'
        );
        option.setAttribute(
          'aria-selected',
          'false'
        );

        const nextOption =
          this.dropdownOptions.find(
            (candidate) =>
              !candidate.disabled &&
              !candidate.hidden
          );

        if (nextOption) {
          this.selectOption(nextOption, false);
          return;
        }

        const bundleChoice =
          this.querySelector(
            'input[value="bundle"]'
          );

        const singleChoice =
          this.querySelector(
            'input[value="single"]'
          );

        if (bundleChoice) {
          bundleChoice.checked = false;
          bundleChoice.disabled = true;
        }

        if (singleChoice) {
          singleChoice.checked = true;
        }

        if (this.dropdownToggle) {
          this.dropdownToggle.disabled = true;
        }

        this.updateChoice();
      }

      async applyDiscount(
        discountCode,
        sections
      ) {
        if (!discountCode) {
          throw new Error(
            'De bundelkorting kon niet worden gevonden.'
          );
        }

        const shopRoot =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          `${shopRoot}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept: 'application/json',
              'X-Requested-With':
                'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: discountCode,
              sections,
              sections_url:
                window.location.pathname,
            }),
          }
        );

        const result = await response.json();

        if (
          !response.ok ||
          result.status
        ) {
          throw new Error(
            result.description ||
              result.message ||
              'De bundelkorting kon niet worden toegepast.'
          );
        }

        return result;
      }

      async onSubmit(event) {
        const bundleSelected =
          this.querySelector(
            'input[value="bundle"]:checked'
          );

        if (!bundleSelected) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const mainVariant =
          this.productForm.querySelector(
            '[name="id"]'
          );

        const quantityInput =
          this.productForm.querySelector(
            '[name="quantity"]'
          );

        const submitButton =
          this.productForm.querySelector(
            '[type="submit"]'
          );

        const discountCode =
          this.discountCodeInput?.value || '';

        if (
          !this.variantInput?.value ||
          !mainVariant?.value
        ) {
          this.showMessage(
            'Kies eerst een beschikbaar speelgoedproduct.'
          );

          return;
        }

        const selectedOption =
          this.dropdownOptions.find(
            (option) =>
              option.dataset.variantId ===
              this.variantInput.value
          );

        if (!selectedOption) {
          this.showMessage(
            'Kies eerst een beschikbaar speelgoedproduct.'
          );

          return;
        }

        submitButton?.setAttribute(
          'aria-disabled',
          'true'
        );

        submitButton?.classList.add(
          'loading'
        );

        submitButton
          ?.querySelector(
            '.loading__spinner'
          )
          ?.classList.remove('hidden');

        this.showMessage();

        const cartUi =
          document.querySelector(
            'cart-notification'
          ) ||
          document.querySelector(
            'cart-drawer'
          );

        const sections =
          cartUi
            ?.getSectionsToRender()
            .map((section) => section.id) ||
          ['cart-icon-bubble'];

        const payload = {
          items: [
            {
              id: Number(
                mainVariant.value
              ),
              quantity: Number(
                quantityInput?.value || 1
              ),
            },
            {
              id: Number(
                this.variantInput.value
              ),
              quantity: 1,
            },
          ],
          sections,
          sections_url:
            window.location.pathname,
        };

        try {
          const currentCart =
            await this.fetchCurrentCart();

          const mainQuantity = Number(
            quantityInput?.value || 1
          );

          const requestedBundleQuantity =
            Number(mainVariant.value) ===
            Number(this.variantInput.value)
              ? mainQuantity + 1
              : 1;

          if (
            !this.hasEnoughInventory(
              selectedOption,
              currentCart,
              requestedBundleQuantity
            )
          ) {
            const inventoryError = new Error(
              'Het laatste exemplaar zit al in je winkelwagen. Kies een ander product.'
            );

            inventoryError.inventoryError = true;
            throw inventoryError;
          }

          const response = await fetch(
            window.routes.cart_add_url,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept: 'application/json',
                'X-Requested-With':
                  'XMLHttpRequest',
              },
              body: JSON.stringify(
                payload
              ),
            }
          );

          let result =
            await response.json();

          if (
            !response.ok ||
            result.status
          ) {
            const inventoryError = new Error(
              response.status === 422
                ? 'Dit product is net uitverkocht of het laatste exemplaar zit al in je winkelwagen. Kies een ander product.'
                : result.description ||
                    result.message ||
                    'Toevoegen is mislukt.'
            );

            inventoryError.inventoryError =
              response.status === 422;

            throw inventoryError;
          }

          try {
            result = await this.applyDiscount(
              discountCode,
              sections
            );
          } catch (discountError) {
            console.error(discountError);

            this.showMessage(
              'De producten zijn toegevoegd, maar de bundelkorting kon niet worden toegepast. Controleer je winkelwagen.'
            );
          }

          await publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                'banzoo-bundle-offer',
              productVariantId:
                mainVariant.value,
              cartData: result,
            }
          );

          if (!cartUi) {
            window.location.href =
              window.routes.cart_url;

            return;
          }

          cartUi.setActiveElement?.(
            submitButton
          );

          if (
            cartUi.matches(
              'cart-notification'
            )
          ) {
            const notificationHtml =
              result.sections?.[
                'cart-notification-product'
              ];

            const notificationItem =
              notificationHtml
                ? new DOMParser()
                    .parseFromString(
                      notificationHtml,
                      'text/html'
                    )
                    .querySelector(
                      '[id^="cart-notification-product-"]'
                    )
                : null;

            result.key =
              notificationItem?.id.replace(
                'cart-notification-product-',
                ''
              ) ||
              result.items?.[0]?.key;
          } else if (
            result.items?.length &&
            !result.key
          ) {
            result.key =
              result.items[0].key;
          }

          cartUi.renderContents(result);
          cartUi.classList.remove(
            'is-empty'
          );
        } catch (error) {
          if (error.inventoryError) {
            this.disableUnavailableOption(
              selectedOption
            );
          }

          this.showMessage(
            error.message ||
              'Er ging iets mis. Probeer het opnieuw.'
          );
        } finally {
          submitButton?.removeAttribute(
            'aria-disabled'
          );

          submitButton?.classList.remove(
            'loading'
          );

          submitButton
            ?.querySelector(
              '.loading__spinner'
            )
            ?.classList.add('hidden');
        }
      }

      showMessage(text = '') {
        if (!this.message) return;

        this.message.textContent = text;
        this.message.hidden = !text;
      }
    }
  );
}
